// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/vue-query';

import { client } from '../client.gen';
import { courseApiPublicEndpointsGetCourses, courseApiPublicEndpointsSignupToCourse, type Options, supportApiPublicEndpointsCreateSupportMessage } from '../sdk.gen';
import type { CourseApiPublicEndpointsGetCoursesData, CourseApiPublicEndpointsGetCoursesResponse, CourseApiPublicEndpointsSignupToCourseData, CourseApiPublicEndpointsSignupToCourseResponse, SupportApiPublicEndpointsCreateSupportMessageData, SupportApiPublicEndpointsCreateSupportMessageResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const courseApiPublicEndpointsGetCoursesQueryKey = (options?: Options<CourseApiPublicEndpointsGetCoursesData>) => createQueryKey('courseApiPublicEndpointsGetCourses', options);

/**
 * Get Courses
 */
export const courseApiPublicEndpointsGetCoursesOptions = (options?: Options<CourseApiPublicEndpointsGetCoursesData>) => queryOptions<CourseApiPublicEndpointsGetCoursesResponse, DefaultError, CourseApiPublicEndpointsGetCoursesResponse, ReturnType<typeof courseApiPublicEndpointsGetCoursesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await courseApiPublicEndpointsGetCourses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: courseApiPublicEndpointsGetCoursesQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const courseApiPublicEndpointsGetCoursesInfiniteQueryKey = (options?: Options<CourseApiPublicEndpointsGetCoursesData>): QueryKey<Options<CourseApiPublicEndpointsGetCoursesData>> => createQueryKey('courseApiPublicEndpointsGetCourses', options, true);

/**
 * Get Courses
 */
export const courseApiPublicEndpointsGetCoursesInfiniteOptions = (options?: Options<CourseApiPublicEndpointsGetCoursesData>) => infiniteQueryOptions<CourseApiPublicEndpointsGetCoursesResponse, DefaultError, InfiniteData<CourseApiPublicEndpointsGetCoursesResponse>, QueryKey<Options<CourseApiPublicEndpointsGetCoursesData>>, number | Pick<QueryKey<Options<CourseApiPublicEndpointsGetCoursesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<CourseApiPublicEndpointsGetCoursesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                offset: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await courseApiPublicEndpointsGetCourses({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: courseApiPublicEndpointsGetCoursesInfiniteQueryKey(options)
});

/**
 * Signup To Course
 */
export const courseApiPublicEndpointsSignupToCourseMutation = (options?: Partial<Options<CourseApiPublicEndpointsSignupToCourseData>>): UseMutationOptions<CourseApiPublicEndpointsSignupToCourseResponse, DefaultError, Options<CourseApiPublicEndpointsSignupToCourseData>> => {
    const mutationOptions: UseMutationOptions<CourseApiPublicEndpointsSignupToCourseResponse, DefaultError, Options<CourseApiPublicEndpointsSignupToCourseData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await courseApiPublicEndpointsSignupToCourse({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create Support Message
 */
export const supportApiPublicEndpointsCreateSupportMessageMutation = (options?: Partial<Options<SupportApiPublicEndpointsCreateSupportMessageData>>): UseMutationOptions<SupportApiPublicEndpointsCreateSupportMessageResponse, DefaultError, Options<SupportApiPublicEndpointsCreateSupportMessageData>> => {
    const mutationOptions: UseMutationOptions<SupportApiPublicEndpointsCreateSupportMessageResponse, DefaultError, Options<SupportApiPublicEndpointsCreateSupportMessageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await supportApiPublicEndpointsCreateSupportMessage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
